var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocials(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17_3649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59858 6.35267C4.32639 6.35267 4.91639 5.76266 4.91639 5.03486C4.91639 4.30705 4.32639 3.71704 3.59858 3.71704C2.87077 3.71704 2.28076 4.30705 2.28076 5.03486C2.28076 5.76266 2.87077 6.35267 3.59858 6.35267Z",
    stroke: "white",
    strokeWidth: 1.12956,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4589 6.35267C16.1867 6.35267 16.7767 5.76266 16.7767 5.03486C16.7767 4.30705 16.1867 3.71704 15.4589 3.71704C14.7311 3.71704 14.1411 4.30705 14.1411 5.03486C14.1411 5.76266 14.7311 6.35267 15.4589 6.35267Z",
    stroke: "white",
    strokeWidth: 1.12956,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1411 5.03491H11.5055",
    stroke: "white",
    strokeWidth: 1.12956,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55201 5.03491H4.91638",
    stroke: "white",
    strokeWidth: 1.12956,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56358 11.2945V12.6123C6.56358 13.0143 6.31978 13.3635 5.97715 13.5084C5.85196 13.5677 5.72018 13.6007 5.57522 13.6007H4.2574C3.71051 13.6007 3.26904 13.1592 3.26904 12.6123V11.2945C3.26904 10.7476 3.71051 10.3062 4.2574 10.3062H5.57522C6.12211 10.3062 6.56358 10.7476 6.56358 11.2945Z",
    stroke: "white",
    strokeWidth: 1.12956,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7884 11.2945V12.6123C15.7884 13.1592 15.347 13.6007 14.8001 13.6007H13.4823C13.3373 13.6007 13.2055 13.5677 13.0803 13.5084C12.7377 13.3635 12.4939 13.0143 12.4939 12.6123V11.2945C12.4939 10.7476 12.9354 10.3062 13.4823 10.3062H14.8001C15.347 10.3062 15.7884 10.7476 15.7884 11.2945Z",
    stroke: "white",
    strokeWidth: 1.12956,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5054 4.04671V6.02343C11.5054 6.56374 11.0574 7.01179 10.5171 7.01179H8.54036C8.00006 7.01179 7.552 6.56374 7.552 6.02343V4.04671C7.552 3.50641 8.00006 3.05835 8.54036 3.05835H10.5171C11.0574 3.05835 11.5054 3.50641 11.5054 4.04671Z",
    stroke: "white",
    strokeWidth: 1.12956,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5055 5.51587C13.0671 6.30656 14.1411 8.00655 14.1411 9.97668C14.1411 10.0887 14.1345 10.1941 14.1214 10.3061",
    stroke: "white",
    strokeWidth: 1.12956,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93615 10.3061C4.92297 10.1941 4.91638 10.0887 4.91638 9.97668C4.91638 8.00655 5.9904 6.30656 7.55201 5.51587",
    stroke: "white",
    strokeWidth: 1.12956,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17_3649",
    x: 0.209869,
    y: 0.987579,
    width: 18.6378,
    height: 14.684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.753037
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_3649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_3649",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocials);
export default __webpack_public_path__ + "static/media/socials.6b17d61363465ab2b57e31c2729151cc.svg";
export { ForwardRef as ReactComponent };